"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COPY_SPECIFIC = void 0;
const GENERIC_1 = require("./GENERIC.js");
exports.COPY_SPECIFIC = {
    ACCEPT: 'Accept',
    ACCEPT_INVITATION: 'Accept Invitation',
    ACCESS_CHANGES_DETECTED: 'Access Changes Detected',
    ACCESS_LOG: 'Access Log',
    ACCOUNT_INFORMATION: 'Account Information',
    ACTION: 'Action',
    ACTIVATE_DAILY_SYNCS: 'To activate daily syncs again, click here!',
    ACTIVE: 'Active',
    ADD_APP_SETTINGS: 'App Settings',
    ADD_A_FILE: 'Add a File',
    ADD_A_LINK: 'Add a Link',
    ADD_A_NEW_APP: 'Add a New App',
    ADD_A_NEW_STAKEHOLDER: 'Add a New Stakeholder',
    ADD_A_NEW_USER: 'Add a New User',
    ADD_CONDITION: 'Add Condition',
    ADD_CUSTOMER: 'Add Customer',
    ADD_FILTERS: 'Add Filters',
    ADD_GROUP: 'Add Group',
    ADD_NEW_APP: 'Add New App',
    ADD_NEW_AROVY_USER: 'Add New Arovy User',
    ADD_NEW_STAKEHOLDER: 'Add New Stakeholder',
    ADD_NEW_USER: 'Add New User',
    ADD_STAKEHOLDERS: 'Add Stakeholders',
    ADD_TASK: 'Add Task',
    ADD_TO_A_TASK: 'Add to a task?',
    ADD_TO_INITIATIVE: 'Add to Initiative',
    ADD_TO_TAG: 'Add to Tag',
    ADD_TO_TASK: 'Add to Task',
    ADMINISTRATION: 'Administration',
    ADMIN_IMPERSONATOR_MODE: 'ADMIN: Impersonator Mode',
    AI_EXPLAIN: 'AI Explain',
    AI_FIX: 'AI Fix',
    AI_RESPONSE_FAILURE: (supportEmailAddress) => 
    // eslint-disable-next-line max-len
    `We're having trouble generating a response right now. Please close the modal and try again. If you continue to see this error, please contact support at <a href="mailto:${supportEmailAddress}">${supportEmailAddress}</a>`,
    ALL: 'All',
    ALL_APPS_MONITORED: 'Great job, all apps are being monitored.',
    ALL_CONDITIONS_ARE_MET: 'All Conditions Are Met (AND)',
    ALL_OTHERS: 'All Others',
    AND: 'And',
    ANY: 'Any',
    ANY_COMPLIANCE_CATEGORY: 'Any Compliance Category',
    ANY_CONDITIONS_ARE_MET: 'Any Conditions Are Met (OR)',
    APEX: 'Apex',
    API_CALLS: 'Api Calls',
    API_DOWNTIME: 'Api Downtime',
    API_KEY_TOKEN: 'Api Key / Token',
    API_NAME: 'API Name',
    API_VERSION: 'Api Version',
    API_VOLUME_EXPLORER: 'API Volume Explorer',
    APP: 'App',
    APPLICATION: 'Application',
    APPLICATIONS: 'Applications',
    APPLICATION_EXPLORER: 'Application Explorer',
    APPLICATION_MANAGEMENT: 'Application Management',
    APPLICATION_OVERVIEW: 'Application Overview',
    APPLICATION_SETUP: 'Application Setup',
    APPLICATION_STATUS: 'Application Status',
    ARCHIVE: 'Archive',
    ARCHIVED_ISSUES: 'Archived Issues',
    ARCHIVE_INITIATIVE: 'Archive Initiative',
    ARE_YOU_SURE_ARCHIVE_INITIATVE: 'Are you sure you would like to archive this initiative?',
    ARE_YOU_SURE_ARCHIVE_INITIATVES: 'Are you sure you want to archive {0} initiatives?',
    ARE_YOU_SURE_DELETE_SCOPE: (count, name) => `Are you sure you want to remove ${count} ${name} from this initiative?`,
    ARE_YOU_SURE_DELETE_VIEW: 
    // eslint-disable-next-line max-len
    'Are you sure you want to delete this view? Any published views will no longer display any Data Dictionary information.',
    ARE_YOU_SURE_REMOVE_PACKAGE_TAGGING: 
    // eslint-disable-next-line max-len
    'Are you sure you want to disable Package Tagging? All package tags will be deleted, and all fields will have their package tags removed.',
    ASSIGNED_TO_ME: 'Assigned To Me',
    ATTACHED_FILES: 'Attached Files',
    AUTOMATION_RULE_INFORMATION: 'Automation Rule Information',
    AVAILABLE_FOR_USE: 'Available For Use',
    A_LOOKUP_ON_OBJECT: 'A lookup on the {0} object',
    BACK: 'Back',
    BACK_TO_LOGIN: 'Back to Login',
    BODY_PLAIN_TEXT_PREVIEW: 'Body (Plain Text Preview)',
    BOUNCE: 'Bounce',
    BULK_EDIT: 'Bulk Edit',
    BULK_TAG: 'Bulk Tag',
    BUSINESS_CONTEXT: 'Business Context',
    CAMPAIGN: 'Campaign',
    CANCEL: 'Cancel',
    CC_EMAILS: 'CC Emails',
    CHANGE: 'Change',
    CHANGES: 'Changes',
    CHANGES_FROM: 'Changes from: ',
    CHANGES_SYNC_TO_SALESFORCE: 'Changes in this column sync directly to Salesforce',
    CHANGE_DETAIL: 'Change Detail',
    CHANGE_DETECTED_ON: 'Change detected on',
    CHANGE_OWNER: 'Change Owner',
    CHANGE_PASSWORD: 'Change Password',
    CHANGE_STATUS: 'Change Status',
    CLASSIFICATION: 'Classification',
    CLEAR_ALL: 'Clear All',
    CLEAR_ENTITY_FILTERS: 'Clear Entity Filters',
    CLEAR_FILTERS: 'Clear Filters',
    CLEAR_SELECTION: 'Clear Selection',
    CLICK_OR_DRAG_FILE_TO_THIS_AREA_TO_UPLOAD: 'Click or drag file to this area to upload',
    CLICK_TO_ADD_LINKS_AND_FILES_TO_INITIATIVE: 'Click the buttons above to add links and files to the initiative',
    CLICK_TO_COPY: 'Click to copy',
    COLOR: 'Color',
    COLUMNS: 'Columns',
    COMMENTS: 'Comments',
    COMPLETE: 'Complete',
    COMPLIANCE: 'Compliance',
    COMPLIANCE_CATEGORIES: 'Compliance Categories',
    COMPLIANCE_CATEGORY: 'Compliance Category',
    CONDITION: 'Condition',
    CONDITION_LOGIC: 'Condition Logic',
    CONFIG: 'Config',
    CONFIGURATION: 'Configuration',
    CONFIGURE_ORGANIZATIONS: GENERIC_1.COPY_GENERIC.CONFIGURE('Organizations'),
    CONFIGURE_TAGS: GENERIC_1.COPY_GENERIC.CONFIGURE('Tags'),
    CONFIRM_ARCHIVE_INITIAIVE: 'Confirm Archive Initiative',
    CONNECT: 'Connect',
    CONNECT_YOUR_INSTANCE: 'Connect Your Instance',
    CONTACT_AROVY_ADMIN: 'Contact your Arovy Admin for help',
    CONTACT_SUPPORT: 'Contact Support',
    CONTACT_US: 'Contact Us',
    CONTAINS: 'Contains',
    CONTENT_TYPE: 'Content Type',
    CONTROLS: 'Controls',
    COPIED: 'Copied',
    COPYING: 'Copying...',
    COPY_FAILED: 'Copy Failed',
    COPY_TO_CLIPBOARD: 'Copy to Clipboard',
    COUNTRY_ISO: 'Country ISO',
    CREATE: 'Create',
    CREATED_AT: 'Created At',
    CREATED_BY: 'Created By',
    CREATE_INITIATIVE: 'Create Initiative',
    CREATE_MONITOR: 'Create Monitor',
    CREATE_MONITOR_UPSELL_BODY: 'Track what matters most. Create custom monitors for proactive insights.',
    CREATE_MONITOR_UPSELL_TITLE: 'Stay Ahead with Custom Monitors!',
    CREATE_NEW_INITIATIVE: 'Create New Initiative',
    CREATE_NEW_MONITOR: 'Create New Monitor',
    CREATE_NEW_TAG: 'Create New Tag',
    CREATE_NEW_TASK: 'Create New Task',
    CREATE_AROVY_ACCOUNT: 'Create Arovy Account',
    CREATE_TAG: 'Create Tag',
    CREATE_TAGS: 'Create Tags',
    CREATING_EMBEDDABLE_LINK: 'Creating an Embeddable Link',
    CRITERIA: 'Criteria',
    CRM_VISIBLE: 'CRM Visible',
    CUSTOM: 'Custom',
    CUSTOMER_VIEW: 'Customer View',
    DAILY_SYNCS_DISABLED: 'Your daily syncs are currently disabled! If you\'ve seen this message multiple times, please contact support.',
    DASHBOARD: 'Dashboard',
    DATA_ACCESS: 'Data Access',
    DATA_DICTIONARY: 'Data Dictionary',
    DATA_GOVERNANCE: 'Data Governance',
    DATA_SECURITY: 'Data Security',
    DATA_SENSITIVITY: 'Data Sensitivity',
    DATE: 'Date',
    DECLINE: 'Decline',
    DEFAULT_VIEW: 'Default View',
    DEFINITION: 'Definition',
    DELEGATE_USER: 'Delegate User',
    DELETE: 'Delete',
    DELETED: 'Deleted',
    DELETE_INTEGRATION: 'Delete Integration',
    DEPLOYMENT_STATUS: 'Deployment Status',
    DESCRIPTION: 'Description',
    DETAILED_LIST_OF_CHANGES: 'Detailed List of Changes',
    DETAILS: 'Details',
    DETECTED_APPLICATIONS: 'Detected Applications',
    DETECTED_DATE: 'Detected Date',
    DIAGNOSTICS: 'Diagnostics',
    DISABLED_CUSTOMERS_COUNT: (count) => `${count} Disabled Customers`,
    DISCONNECT: 'Disconnect',
    DISPLAY_NAME: 'Display Name',
    DONE: 'Done',
    DOWNLOAD_FIELDSPY: 
    // eslint-disable-next-line max-len
    'Population percentage is available for objects that have been analyzed with FieldSpy. <a target="_blank" rel="noopener norefererr" href="https://appexchange.salesforce.com/appxListingDetail?listingId=a0N3u00000QsXfSEAV">Click here</a> to download the package from the Salesforce AppExchange.',
    EDIT: 'Edit',
    EDITING: 'Editing',
    EDITING_LABEL: (label) => `Editing ${label}`,
    EDIT_APP: 'Edit App',
    EDIT_SETTINGS: 'Edit Settings',
    EDIT_TAGS: 'Edit Tags',
    EMAIL: 'Email',
    EMAIL_INFORMATION: 'Email Information',
    EMAIL_IN_USE: 'Email is already in use. Please try another.',
    EMAIL_NOTIFICATIONS: 'Email Notifications',
    EMAIL_TEMPLATE_INFORMATION: 'Email Template Information',
    EMPTY: 'Empty',
    ENABLED_CUSTOMERS: 'Enabled Customers',
    ENABLED_CUSTOMERS_COUNT: (count) => `${count} Enabled Customers`,
    ENABLE_BY_DEFAULT: 'Enable by Default',
    ENABLE_REPORTS: 'Enable Reports',
    ENTITIES: 'Entities',
    ENTITY_OWNER: 'Entity Owner',
    ENTITY_STAKEHOLDER: 'Entity Stakeholder',
    EQUALS: 'Equals',
    ERROR: 'Error',
    EVALUATION_CRITERIA: 'Evaluation Criteria',
    EVENT: 'Event',
    EVENT_DATE: 'Event Date',
    EVENT_IDENTIFIER: 'Event Identifier',
    EVERYTHING_LOOKS_GREAT: 'Everything looks great!',
    EXCLUDE_EMPTY_VALUES: 'Exclude empty values',
    EXCLUDING_EMPTY: 'Excluding Empty',
    EXIT: 'Exit',
    EXPLORE: 'Explore',
    EXPORT: 'Export',
    EXTERNAL_LINKS: 'External Links',
    FEATURE_FLAGS: 'Feature Flags',
    FEATURE_FLAG_GROUP: 'Feature Flag Group',
    FIELD: 'Field',
    FIELDS: 'Fields',
    FIELD_CANNOT_EXCEED: (fieldName, max) => `${fieldName} cannot exceed ${max} characters`,
    FIELD_COUNT: 'Field Count',
    FIELD_INFORMATION: 'Field Information',
    FIELD_NAME: 'Field Name',
    FIELD_REQUIRED: (fieldName) => `${fieldName} is required`,
    FIELD_TO_UPDATE: 'Field to Update',
    FIELD_TYPE: 'Field Type',
    FIELD_USAGE: 'Field Usage',
    FILE_IS_TOO_LARGE: (maxSize) => `File is too large. Must be less than ${maxSize / 1024 / 1024}MB.`,
    FILTERS: 'Filters',
    FILTERS_APPLIED: 'Filters applied',
    FIRST_NAME: 'First Name',
    FOLDER: 'Folder',
    FOLLOW: 'Follow',
    FOLLOWING: 'Following',
    FORGOT_PASSWORD: 'Forgot Password',
    FORMULA: 'Formula',
    FORMULA_REFERENCES_FIELDS: 'Formula references {0} fields:',
    GENERATE_LINK: 'Generate Link',
    GLOBAL_MUTE: 'Global Mute',
    GOOGLE: 'Google',
    GO_TO_DICTIONARY: 'Go to Dictionary',
    GO_TO_SETTINGS: 'Go to Settings',
    GROUP: 'Group',
    GROUPS: 'Groups',
    GROUP_BY: 'Group By:',
    HELP_CENTER: 'Help Center',
    HELP_TEXT: 'Help Text',
    HERE: 'here',
    HIDDEN: 'Hidden',
    HIDE: 'Hide',
    HIDE_LIST: 'Hide List',
    ID: 'ID',
    IMPACTED_APPLICATIONS: 'Impacted Applications',
    IMPACT_ANALYSIS: 'Impact Analysis',
    INACTIVE: 'Inactive',
    INCIDENT_LOG: 'Incident Log',
    INDIVIDUAL: 'Individual',
    INITIATIVE: 'Initiative',
    INITIATIVES: 'Initiatives',
    INITIATIVES_SELECTED: 'initiatives selected',
    INITIATIVE_NAME: 'Initiative Name',
    INTEGRATED_APPS: 'Integrated Apps',
    INTEGRATED_APP_USAGE: 'Integrated App Usage',
    INTEGRATIONS: 'Integrations',
    INTEGRATION_USER: 'Integration User',
    INVALID_LINK: 'Invalid Link',
    INVESTIGATE: 'Investigate',
    INVITED: 'Invited',
    INVITE_USER: 'Invite User',
    ISSUES: 'Issues',
    ISSUES_SUMMARY: 'Issues Summary',
    IS_ANY: 'Is Any',
    IS_READ_ONLY: 'Is Read Only',
    ITEMS: 'Items',
    JIRA: 'Jira',
    JIRA_INCOMPLETE_STATUS: 'Some of the Jira statuses aren\'t mapped to an Arovy Status. ',
    JIRA_INTEGRATION: 'Jira Integration',
    JIRA_ISSUES: 'Jira Issues',
    JIRA_SET_UP_MAPPING: ' to set up a mapping',
    JIRA_UNMAPPED_STATUS: 'This status isn\'t mapped to an Arovy Status. ',
    LABEL: 'Label',
    LANDING_PAGE_INFORMATION: 'Landing Page Information',
    LAST_NAME: 'Last Name',
    LAST_RUN_DATE: 'Last Run Date',
    LAST_SYNC_SUMMARY: 'Last Sync Summary',
    LEARN_MORE: 'Learn More',
    LINK: 'Link',
    LINK_EXPIRED: 'Link Expired',
    LINK_EXPIRED_DESCRIPTION: (supportEmailAddress) => 
    // eslint-disable-next-line max-len
    `The link you followed has expired. Invitations automatically expire after 48 hours. Please contact the sender for a new invitation link, or reach out to <a href="mailto:${supportEmailAddress}">${supportEmailAddress}</a>`,
    LINK_NEW_ORGANIZATION: 'Link New Organization',
    LIST_INFORMATION: 'List Information',
    LOCKED: 'Locked',
    LOGIN: 'Login',
    LOGIN_HISTORY_ID: 'Login History ID',
    LOGOUT: 'Logout',
    MANAGE: 'Manage',
    MATCH_TYPE: 'Match Type',
    METADATA_IMPORT: 'Metadata Import',
    METADATA_IMPORT_LOGS: 'Metadata Import Logs',
    METADATA_TIMELINE: 'Metadata Timeline',
    MIXED: 'Mixed',
    MODIFIED_BY: 'Modified By',
    MONITORED_APPLICATIONS: 'Monitored Applications',
    MONITORS: 'Monitors',
    MONITORS_AND_LOGS: 'Monitors and Logs',
    MONITOR_APP: 'Monitor App',
    MONITOR_BUILDER: 'Monitor Builder',
    MONITOR_DETAILS: 'Monitor Details',
    MONITOR_SETTINGS: 'Monitor Settings',
    MONITOR_UPSELL_LINE1: 
    // eslint-disable-next-line max-len
    'Don\'t allow unexpected changes to connected application access put your business at risk. Instantly create monitors to receive real-time alerts when Arovy detects changes to field and object level access, API volume, and system uptime.',
    MONITOR_UPSELL_LINE2: 'Contact us today to learn more about Arovy\'s Protect package',
    NAME: 'Name',
    NEED_HELP_CREATING_API_TOKEN: 'Need help creating an API Token?',
    NEW_VALUE: 'New Value',
    NEXT: 'Next',
    NEXT_WEEK: 'Next Week',
    NO: 'No',
    NONE: 'None',
    NONE_PARENTHETICAL: '(none)',
    NOT: 'Not',
    NOTES: 'Notes',
    NOTIFICATION_FREQUENCY: 'Notification Frequency',
    NOT_MONITORED: 'Not Monitored',
    NOT_MONITORED_TOOLTIP_END: ' to start monitoring this entity.',
    NOT_MONITORED_TOOLTIP_START: 
    // eslint-disable-next-line max-len
    'This entity is not currently being monitored by Arovy. Add additional objects to the Integrated Apps configuration ',
    NO_APPLICATION: 'No Application',
    NO_CHANGES_MADE_DURING_TIMEFRAME: 'No changes made during this timeframe',
    NO_CLASSIFICATION: 'No Classification',
    NO_COMPLIANCE_CATEGORIES: 'No Compliance Categories',
    NO_CONNECTED_APPS: 'No Connected Applications',
    NO_FIELD_USAGE: 'No Field Usage',
    NO_GROUPS: 'No Groups',
    NO_ISSUES_ARCHIVED: 'There are no archived issues.',
    NO_ISSUES_SNOOZED: 'There are no snoozed issues.',
    NO_ISSUES_TO_REPORT: 'There are no issues to report.',
    NO_LABELED: (label) => `No ${label !== null && label !== void 0 ? label : ''}`,
    NO_LAYOUTS: 'No Layouts',
    NO_OWNER: 'No Owner',
    NO_PREFIX: 'No Prefix',
    NO_PROFILE: 'No Profile',
    NO_SECTION: 'No Section',
    NO_SECTIONS_AVAILABLE: 'No Sections Available',
    NO_STAKEHOLDERS: 'No Stakeholders',
    NO_TAGS: 'No Tags',
    NO_UNMONITORED_APPS_FOUND: 'No unmonitored applications found.',
    NUMBER_SELECTED: (num) => `${num} Selected`,
    OBJECT: 'object',
    OBJECTS: 'Objects',
    OBJECT_AND_FIELD_USAGE_ACTIVITY: 'Object & Field Usage Activity',
    OK: 'Ok',
    OKTA: 'Okta',
    OLD_VALUE: 'Old Value',
    ONE_MONTH: 'One Month',
    OPEN_IN_SALESFORCE: 'Open in Salesforce',
    OPERATION: 'Operation',
    OPERATIONAL: 'Operational',
    OPERATOR: 'Operator',
    OR: 'Or',
    ORGANIZATION: 'Organization',
    ORGANIZATION_PREFERENCES: 'Organization Preferences',
    OR_LOGIN_USING: 'Or login using',
    OUTAGE: 'Outage',
    OVERVIEW: 'Overview',
    OWNER: 'Owner',
    OWNERS: 'Owners',
    OWNERS_IMPACTED: 'Owners Impacted',
    PACKAGE_TAGGING: 'Package Tagging',
    PAGE_ACTION_INFORMATION: 'Page Action Information',
    PAGE_URL: 'Page URL',
    PARDOT_IS_SYNCING: 'Pardot is syncing',
    PARENT_OBJECT: 'Parent Object',
    PERFORMANCE_OVERVIEW: 'Performance Overview',
    PERISCOPE: 'Periscope',
    PERSONAL_INFO: 'Personal Info',
    POLICY_ID: 'Policy ID',
    POLICY_OUTCOME: 'Policy Outcome',
    POPULATED: 'Populated',
    POPULATED_BY: 'Populated By',
    POPULATION_PERCENTAGE: 'Population %',
    POPULATION_PERCENT_LAST_ANALYZED: 'Last Population Analysis Date',
    POTENTIAL_ISSUES: 'Potential Issues',
    POWERED_BY: 'Powered by',
    PRIORITY_PAGE: 'Priority Page?',
    PRIVACY_POLICY: 'Privacy Policy',
    PROACTIVE_APPLICATION_PROTECTION: 'Proactive Application Protection',
    PROCESS_BUILDERS: 'Process Builders',
    PUBLIC_LIST: 'Public List',
    PUBLISHED: 'Published',
    QUICK_ACCESS: 'Quick Access',
    QUICK_FIND: 'Quick Find',
    READ_BY: 'Read By',
    READ_ONLY: 'Read Only',
    READ_REQUESTS_ONLY: 'Read Requests Only',
    REAL_TIME: 'Real Time',
    REAL_TIME_ALERTS_UPSELL: 'Real-Time Alerts Across Your Connected Applications',
    REAL_TIME_ALERTS_UPSELL_LINE1: 'Don\'t allow unexpected changes to connected apps put your business at risk.',
    REAL_TIME_ALERTS_UPSELL_LINE2: 
    // eslint-disable-next-line max-len
    'Create monitors to receive real-time alerts to detect changes to field and object level access, API volume, and system uptime.',
    REAL_TIME_ALERTS_UPSELL_LINE3: 'Contact us today to learn more about Arovy\'s Protect package',
    RECIPIENTS: 'Recipients',
    RECOMMENDED_ACTION_TEMPLATES: 'Recommended Action Templates',
    REFERENCES: 'references',
    REFERENCE_COUNT: 'Reference Count',
    REMOVE: 'Remove',
    REMOVE_FROM_INITIATIVE: 'Remove from Initiative',
    REMOVE_ISSUE: 'Remove Issue',
    RENAME: 'Rename',
    REPEAT: 'Repeat',
    REPLY_TO: 'Reply To',
    REPORTS: 'Reports',
    REPORTS_CANNOT_BE_FOLLOWED: 'Reports cannot be followed',
    REQUIRED: 'Required',
    RESEND_EMAIL: 'Resend Email',
    RESEND_INVITE: 'Resend Invite',
    RESET: 'Reset',
    RESET_PASSWORD: 'Reset Password',
    RESTORE: 'Restore',
    RETURN: 'Return',
    REVERT: 'Revert',
    REVIEW: 'Review',
    REVOKE_APP_ACCESS: 'Revoke App Access',
    RE_EVALUATE_AFTER_FIELD_CHANGE: 'Re-evaulate after Field Change',
    RULE_CRITERIA: 'Rule Criteria',
    SALESFORCE_LIGHTNING_URLS: 'Salesforce Lightning URLs',
    SALESFORCE_OBJECT_MANAGER: 'Salesforce Object Manager',
    SALESFORCE_ORGS: 'Salesforce Orgs',
    SALESFORCE_SETUP: 'Salesforce Setup',
    SALESFORCE_SYNC_FAILURE: 'There was an issue with your latest sync. Please contact support.',
    SALESFORCE_SYNC_IN_PROGRESS: 'Arovy is currently syncing with Salesforce.',
    SALESFORCE_SYNC_SUCCESS: 'Your latest Salesforce sync completed successfully.',
    SAVE: 'Save',
    SAVED_VIEWS: 'Saved Views',
    SAVE_FILTERS_AS_NEW_VIEW: 'Save Filters as New View',
    SAVE_NEW_TASK: 'Save New Task',
    SCHEDULED_FOR: 'Scheduled For',
    SCOPE: 'Scope',
    SCOPES: 'Scopes',
    SCOPES_SELECTED: 'scopes selected',
    SCORE_CHANGE: 'Score Change',
    SCORING_CATEGORY: 'Scoring Category',
    SEARCH_ACTIONS: 'Search Actions',
    SEARCH_ENTITIES: 'Search Entities',
    SEARCH_FOR_DATA_ACCESS: 'Search for Objects',
    SECTION: 'Section',
    SELECT: 'Select',
    SELECTED: 'Selected',
    SELECT_ADMIN: 'Select Admin',
    SELECT_ALL: 'Select all',
    SELECT_AN_APP: 'Select an App',
    SELECT_AN_APPLICATION: 'Select an Application',
    SELECT_A_TAG: 'Select a tag',
    SELECT_DATE: 'Select Date',
    SELECT_GROUP: 'Select Group',
    SELECT_USER: 'Select User',
    SENDER: 'Sender',
    SEND_INSTRUCTIONS: 'Send Instructions',
    SENSITIVE_FIELDS_FOLLOWED: 'Sensitive Fields Followed',
    SENSITIVE_FIELDS_FOLLOWED_MESSAGE: (count) => `You are now following ${count} sensitive fields. Great Job!`,
    SENT_AT: 'Sent at',
    SETTINGS: 'Settings',
    SETUP_AUDIT_TRAIL: 'Setup Audit Trail',
    SETUP_AUDIT_TRAIL_EVENT: 'Setup Audit Trail Event',
    SETUP_CRITICAL_APPLICATIONS: 'Setup Critical Applications',
    SETUP_CRITICAL_APPLICATIONS_MESSAGE: 'Maximize the power of Arovy by setting up your critical applications and stay informed and in control.',
    SHOW_HIDDEN_APPLICATIONS: 'Show Hidden Applications',
    SLACK: 'Slack',
    SLACK_URL: 'Slack URL',
    SNOOZE: 'Snooze',
    SNOOZED_ISSUES: 'Snoozed Issues',
    AROVY: 'Arovy',
    AROVY_USERS: 'Arovy Users',
    SOURCE_IP: 'Source IP',
    SOURCE_NAMESPACE_PREFIX: 'Source Namespace Prefix',
    STAKEHOLDERS: 'Stakeholders',
    STAKEHOLDERS_IMPACTED: 'Stakeholders Impacted',
    STANDARD: 'Standard',
    STATE: 'State',
    STATUS: 'Status',
    STATUS_PAGE_ERROR: 'Status Page Error',
    SUBJECT: 'Subject',
    SUBMIT: 'Submit',
    SUBMITTING: 'Submitting',
    SUBSCRIBE: 'Subscribe',
    SUCCESS: 'Success',
    SUCCESSFULLY_ADDED_TO_INITIATIVE: 'Successfully added to Initiative!',
    SUCCESSFULLY_ADDED_TO_TAG: 'Successfully added to Tag!',
    SUCCESSFULLY_ADDED_TO_TASK: 'Successfully added to Task!',
    SUMMARY: 'Summary',
    SUPPORT: 'Support',
    SWITCH: 'Switch',
    SYNC: 'Sync',
    SYNC_BEHAVIOR: 'Sync Behavior',
    SYNC_COMPLETED: 'Sync Completed',
    SYNC_IN_PROGRESS: 'Sync in Progress',
    SYNC_NOW: 'Sync Now',
    TAG: 'Tag',
    TAGS: 'Tags',
    TAG_COUNT: 'Tag Count',
    TAG_NAME: 'Tag Name',
    TASK: 'Task',
    TASKS: 'Tasks',
    TASK_NAME: 'Task Name',
    TEAM: 'Team',
    TEMPLATE_TYPE: 'Template Type',
    TERMS_OF_SERVICE: 'Terms of Service',
    THIS_FIELD_HAS: 'This field has',
    TIMELINE: 'Timeline',
    TIMELINE_SUMMARY: 'Timeline Summary',
    TITLE: 'Title',
    TOMORROW: 'Tomorrow',
    TOO_MANY_SELECTED: 'Too Many Selected',
    TOTAL: 'Total',
    TOTAL_DATA_SYNC: 'Total Data Synced',
    TOTAL_ENTITIES: 'Total Entities',
    TO_ORGANIZATION: 'To Organization',
    TRACK_ACTIVITIES: 'Track Activities',
    TRACK_FIELD_HISTORY: 'Track Field History',
    TRACK_SETUP_AUDIT_TRAIL_ACTIVITY: 'Track Setup Audit Trail Activity. For example track when users are granted System Admin profiles.',
    TURN_OFF_STATUS_SYNC: 'Turn Off Status Sync',
    TURN_ON_STATUS_SYNC: 'Turn On Status Sync',
    TYPE: 'Type',
    UNABLE_TO_UDPATE_MANAGED_SALESFORCE: 'Unable to update due to being part of a managed package.',
    UNABLE_TO_UPDATE_STANDARD_SALESFORCE: 'Unable to update for standard objects. Please update in Salesforce directly.',
    UNFOLLOW: 'Unfollow',
    UNHIDE: 'Unhide',
    UNKNOWN: 'Unknown',
    UNREVIEWED: 'Unreviewed',
    UNSAVED_SUGGESTION: 'Unsaved Suggestion.',
    UNSUPPORTED_FILE_TYPE_GENERIC: 'Unsupported file type.',
    UNSUPPORTED_FILE_TYPE_IMAGE: 'Unsupported file type. Only JPEG and PNG supported.',
    UPDATE: 'Update',
    UPDATED_AT: 'Updated At',
    UPDATED_BY: 'Updated By',
    UPDATE_FILE: 'Update File',
    UPDATE_LINK: 'Update Link',
    UPDATING: 'Updating',
    UPLOAD_YOUR_PHOTO: 'Upload Your Photo',
    USAGE_ACTIVITY: 'Usage Activity',
    USER: 'User',
    USERNAME: 'Username',
    USERNAME_TO_AUTHENTICATE_WITH: 'Username to authenticate with.',
    USERS: 'Users',
    USER_AGENT: 'User Agent',
    USER_ID: 'User Id',
    USER_INVITATION_OPTIONS: 'User Invitation Options',
    USER_SETTINGS: 'User Settings',
    VALIDATION_RULE_ISSUES: 'Validation Rule Issues',
    VALUE: 'Value',
    VERSION: 'Version',
    VIEW: 'View',
    VIEW_ALL_ISSUES: 'View All Issues',
    VIEW_ARCHIVED: 'View Archived',
    VIEW_CONNECTED_APPS_PAGE: 'View Connected Apps Page',
    VIEW_DETAILED_CHANGES: 'View Detailed Changes',
    VIEW_INITIATIVE: 'View Initiative',
    VIEW_IS_SHAREABLE: 
    // eslint-disable-next-line max-len
    'This view is now shareable with a link. Anyone with this link can view the contents of this page, but cannot change any filters or columns.',
    VIEW_POTENTIAL_ISSUES: 'View Potential Issues',
    VIEW_SNOOZED: 'View Snoozed',
    VISIT_ATLASSIAN_HELP_PAGE: 'Visit Atlassian\'s Help Page.',
    WORKFLOW_DETAIL: 'Workflow Detail',
    WORKFLOW_RULE_INFORMATION: 'Workflow Rule Information',
    YES: 'Yes'
};
//# sourceMappingURL=SPECIFIC.js.map